<template>
  <v-dialog v-model="visible" max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="button-container">
        <slot name="button">
          <v-btn color="secondary" class="secondary button-info" elevation="0" dark fab>
            <v-icon dark>mdi-help</v-icon>
          </v-btn>
        </slot>
      </div>
    </template>
    <v-card>
      <v-card-title class="headline" v-if="title">{{ title }}</v-card-title>
      <v-card-text v-if="description">{{ description }}</v-card-text>
      <slot/>
    </v-card>
  </v-dialog>
</template>

<script>

import Component from 'vue-class-component';
import Vue from 'vue';
import { Components } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import DynameatSpinner from '@dynameat/components/DynameatSpinner';

@Component
@Components({ DynameatSpinner })
export default class DynameatInfoModal extends Vue {
  @Prop({ type: String, default: undefined }) title;

  @Prop({ type: String, default: undefined }) description;

  visible = false;
}
</script>

<style scoped>
.v-dialog--active {
  background: white;
}
.button-info {
  color: var(--v-primary-base) !important;
  max-width: 30px;
  max-height: 30px;
}

.button-container {
  display: inline-flex;
}
</style>
